import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  applyLeaveTable: {
    backgroundColor: "#fff",
    borderRadius: "5px",
    marginBottom: ".5rem",
    overflowY: "hidden",
    overflowX: "hidden",
    border: ".5px solid rgba(0, 0, 0, .08)",
    height: "315px",
    "& .leave-type-text-header": {
      padding: "20px 20px 0",
      "& .leave-type-text-header-apply": {
        display: "flex",
        alignItems: "center",
      },
    },

    "& .leave-type-card-apply-leave-page": {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
      gridGap: ".8rem",
      margin: "20px",
      gridAutoFlow: "column",

      "& .leave-type-card-apply-leave-page-card": {
        backgroundColor: "#fff",
        boxShadow: "0 0 4px 2px rgba(0, 0, 0, .04)",
        textAlign: "center",
        minWidth: "186px",
        maxWidth: "200px",
        height: "210px",
        float: "left",
        marginLeft: "10px",
        marginBottom: "0",
        padding: "20px",
        overflow: "hidden",
        transition: "all .3s",
        borderRadius: "4px",
        "& .leave-type-card-apply-leave-page-card-p-header": {
          marginBottom: "10px",
          fontWeight: "600",
          color: "grey",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
        "& .leave-type-card-apply-leave-page-card-header-icon": {
          color: "#96bc42 !important",
          background: "transparent !important",
          fontSize: "25px",
          fontWeight: "600",
          marginBottom: "3px",
          display: "inline-block",
        },
        "& .leave-type-card-apply-leave-page-card-p": {
          marginBottom: "0",
          paddingTop: "10px",
          fontSize: "14px",
        },
      },
    },
  },
  heading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  customTextField: {
    "& input:placeholder": {
      fontSize: "13px",
    },
    marginTop: "5px !important",
    border: "1px solid #ced4da",
  },
}));
